import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  100% {
    transform: rotate(1turn);
  }
`;

interface SpinnerContainerProps {
  size: number;
}

const SpinnerContainer = styled.div<SpinnerContainerProps>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #774eff 94%, #0000) top/ ${(props) => ((props.size * 3.8) / 24).toFixed(1)}px
      ${(props) => ((props.size * 3.8) / 24).toFixed(1)}px no-repeat,
    conic-gradient(#0000 30%, #774eff);
  mask: radial-gradient(farthest-side, #0000 calc(100% - ${(props) => ((props.size * 3.8) / 24).toFixed(1)}px), #000 0);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - ${(props) => ((props.size * 3.8) / 24).toFixed(1)}px),
    #000 0
  );
  animation: ${spin} 1s infinite linear;
`;

interface LoadingSpinnerProps {
  className?: string;
  size?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className, size = 24 }) => {
  return <SpinnerContainer className={className} size={size} />;
};
